import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '@environments/environment';
import { RespInterface, RespListInterface } from '@common/ports/interfaces';
import { PortfolioAbstraction } from '../../../../ports/abstraction';
import { PortfolioInterface } from '../../../../ports/interfaces';
import { ValidatorFormGroupHelper } from '@common/domain/helpers';


@Injectable({
  providedIn: 'root'
})
export class PortfolioRepository extends PortfolioAbstraction {

  private http = inject(HttpClient);
  private formData = inject(ValidatorFormGroupHelper);

  private readonly _baseUrlPortfolioCreate: string = environment.baseUrlPortfolioCreate;
  private readonly _baseUrlPortfolioDelete: string = environment.baseUrlPortfolioDelete;
  private readonly _baseUrlPortfolioList: string = environment.baseUrlPortfolioList;
  private readonly _baseUrlPortfolioRead: string = environment.baseUrlPortfolioRead;
  private readonly _baseUrlPortfolioUdate: string = environment.baseUrlPortfolioUdate;
  //Client
  private readonly _baseUrlPortfolioListClient: string = environment.baseUrlPortfolioListClient;

  override list(query: string): Observable<RespListInterface<PortfolioInterface>> {
    const url = this._baseUrlPortfolioList;
    return this.http.get<RespListInterface<PortfolioInterface>>(`${url}/${query}`);
  }

  override create(portfolio: PortfolioInterface): Observable<RespInterface<PortfolioInterface>> {
    const url = this._baseUrlPortfolioCreate;
    const { institutions, ...newPortfolio } = portfolio;

    const dataPortfolio = this.formData.formData(newPortfolio);

    return this.http.post<RespInterface<PortfolioInterface>>(`${url}`, dataPortfolio);
  }

  override read(id: string): Observable<RespInterface<PortfolioInterface>> {
    const url: string = this._baseUrlPortfolioRead;
    return this.http.get<RespInterface<PortfolioInterface>>(`${url}/${id}`);
  }

  override update(portfolio: PortfolioInterface): Observable<RespInterface<string>> {
    const url: string = this._baseUrlPortfolioUdate;

    const { id, institutions, ...newPortfolio } = portfolio;

    const dataPortfolio = this.formData.formData(newPortfolio);

    return this.http.patch<RespInterface<string>>(`${url}/${id}`, dataPortfolio);
  }

  override delete(id: string): Observable<RespInterface<PortfolioInterface>> {
    const url: string = this._baseUrlPortfolioDelete;
    return this.http.delete<RespInterface<PortfolioInterface>>(`${url}/${id}`);
  }

  override listPortfolioClient(): Observable<RespListInterface<PortfolioInterface>> {
    const url = this._baseUrlPortfolioListClient;
    return this.http.get<RespListInterface<PortfolioInterface>>(`${url}`);
  }
}
